import { action, isAbortError } from '@reatom/framework'

import { Result, Option } from '@blade/std-lib'
import { UnknownError } from '@root/shared'

import { WikiPageSummary } from '../model/wiki-page-summary'

interface GetWikiSummaryRequestActionParams {
  language: string
  title: string
}

export const getWikiSummaryRequestAction = action(
  async (
    ctx,
    params: GetWikiSummaryRequestActionParams,
  ): Promise<Result.Result<WikiPageSummary, UnknownError>> => {
    try {
      const url = `https://${params.language}.wikipedia.org/api/rest_v1/page/summary/${params.title}`

      const response = await ctx.schedule(() => fetch(url))

      if (!response.ok) {
        return Result.fail(
          UnknownError.fromUnknown(
            `Wiki summary request failed: ${response.status}`,
          ),
        )
      }

      const json = (await ctx.schedule(() => response.json())) as unknown

      const decoded = WikiPageSummary.decode(json)

      if (Option.isNone(decoded)) {
        return Result.fail(
          UnknownError.fromUnknown('Failed to decode wiki page summary'),
        )
      }

      return Result.succeed(decoded.value)
    } catch (error) {
      if (isAbortError(error)) {
        throw error
      }
      return Result.fail(UnknownError.fromUnknown(error))
    }
  },
  'getWikiSummaryRequestAction',
)
